<template>
  <div class="pricing-container" :class="{'pricing-container-mobile': fromMobile}">
    <div id="pricing-compare">
      <div class="container-back-non-edu-plan">
        <div class="back-non-edu-plan back-non-edu-plan_mobile" v-if="isShowBackToNonEdu">
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
          >
            <path d="M0.219738 5.59278C-0.073245 5.2648 -0.073245 4.73218 0.219738 4.40421L3.21988 1.04578C3.51287 0.717812 3.98867 0.717812 4.28165 1.04578C4.57464 1.37375 4.57464 1.90638 4.28165 2.23435L2.56126 4.1602L11.25 4.1602C11.6648 4.1602 12 4.5354 12 4.9998C12 5.46421 11.6648 5.83941 11.25 5.83941L2.56126 5.83941L4.28165 7.76526C4.57464 8.09323 4.57464 8.62585 4.28165 8.95383C3.98867 9.2818 3.51287 9.2818 3.21988 8.95383L0.219738 5.5954V5.59278Z" fill="#348EF6" />
          </svg>
          <a class="primary" href="javascript:void(0);" @click="backToNonEducational">
            Back to Non-educational plans</a>
        </div>
      </div>

      <div class="pricing-toggle" :class="{'show-edu-plan': isShowBackToNonEdu}">
        <div class="toggle__bar" v-if="!isShowBackToNonEdu">
          <div class="relative">
            <div class="flex items-center">
              <div
                class="toggle__button annual"
                :class="{'active': planName == 'annual'}"
                @click="_togglePlan('annual')"
              >
                Annual
              </div>
              <div
                class="toggle__button monthly"
                :class="{'active': planName == 'monthly'}"
                @click="_togglePlan('monthly')"
              >
                Monthly
              </div>
              <div
                v-if="!isHiddenSwitchPlanEdu"
                class="toggle__button educational"
                :class="{'active': planName == 'educational'}"
                @click="_togglePlan('educational')"
              >
                Edu
              </div>
            </div>
          </div>
        </div>
        <PricingHeader
          :planName="planName"
          :is-mobile="fromMobile"
        />
        <span class="back-non-edu-plan back-non-edu-plan_desktop" v-if="isShowBackToNonEdu">
          <a class="primary" href="javascript:void(0);" @click="backToNonEducational">
            Back to Non-educational plans
          </a>
        </span>
      </div>
      <!-- All prices desktop -->
      <div class="pricing-desktop is-desktop">
        <PricingDesktopMonthly
          id="toggle-plan-monthly"
          class="hidden"
          :class="{'active': planName == 'monthly'}"
          @learnmore="learnmore"
          :permission="permission"
          @upgradePlan="upgradePlan"
        />

        <PricingDesktopAnnual
          id="toggle-plan-annual"
          class="hidden"
          :class="{'active': planName == 'annual'}"
          @learnmore="learnmore"
          :permission="permission"
          @upgradePlan="upgradePlan"
        />

        <PricingDesktopEdu
          id="toggle-plan-educational"
          class="hidden"
          :class="{'active': planName == 'educational'}"
          @learnmore="learnmore"
          :permission="permission"
          @upgradePlan="upgradePlan"
        />
        <div class="title-open-edu py-2" v-if="isShowTitleOpenEdu">
          <span>
            <b>Educational plans</b>
          </span> —  Special rates for teachers, students and nonprofit organisations.
          <a class="primary" href="#upgrade-your-plan" @click="openEducation()">Learn more </a>
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
          >
            <path d="M11.7803 5.59278C12.0732 5.2648 12.0732 4.73218 11.7803 4.40421L8.78012 1.04578C8.48713 0.717812 8.01133 0.717812 7.71835 1.04578C7.42536 1.37375 7.42536 1.90638 7.71835 2.23435L9.43874 4.1602L0.750037 4.1602C0.335173 4.1602 0 4.5354 0 4.9998C0 5.46421 0.335173 5.83941 0.750037 5.83941L9.43874 5.83941L7.71835 7.76526C7.42536 8.09323 7.42536 8.62585 7.71835 8.95383C8.01133 9.2818 8.48713 9.2818 8.78012 8.95383L11.7803 5.5954V5.59278Z" fill="#348EF6" />
          </svg>
        </div>
      </div>
      <PricingTableDesktop
        :activePlan="planName"
        :togglePlan="_togglePlan"
        :permission="permission"
      />
    </div>

    <!-- All prices mobile -->
    <div class="pricing-mobile is-touch">
      <PricingMobileAnnual
        id="toggle--annual"
        class="toggle-plan-mobile"
        v-if="planName == 'annual'"
        :permission="permission"
        @upgradePlan="upgradePlan"
      />

      <PricingMobileMonthly
        id="toggle--monthly"
        class="toggle-plan-mobile"
        v-if="planName == 'monthly'"
        :permission="permission"
        @upgradePlan="upgradePlan"
      />

      <PricingMobileEdu
        id="toggle--educational"
        class="toggle-plan-mobile"
        v-if="planName == 'educational'"
        :permission="permission"
        @upgradePlan="upgradePlan"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Config from '@/config'
import Utils from '@/util'

import PricingDesktopMonthly from './PricingDesktopMonthly.vue'
import PricingDesktopAnnual from './PricingDesktopAnnual.vue'
import PricingDesktopEdu from './PricingDesktopEdu.vue'
import PricingMobileAnnual from './PricingMobileAnnual.vue'
import PricingMobileMonthly from './PricingMobileMonthly.vue'
import PricingMobileEdu from './PricingMobileEdu.vue'
import PricingHeader from './PricingHeader.vue'
import PricingTableDesktop from './PricingTableDesktop.vue'

import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'

const PLAN_GROUPS = ['annual', 'one-time', 'educational', 'monthly']

export default {
  name: 'UserPricing',
  components: {
    PricingDesktopMonthly,
    PricingDesktopAnnual,
    PricingDesktopEdu,
    PricingMobileAnnual,
    PricingMobileMonthly,
    PricingMobileEdu,
    PricingHeader,
    PricingTableDesktop,
  },
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hiddenPlanEdu: true,
      showTitleOpenEdu: true,
      planName: 'annual',
      planColour: '',
      showDetails: false,
      domain: '',
      fromMobile: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isShowBackToNonEdu() {
      return !this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isShowTitleOpenEdu() {
      return this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isHiddenSwitchPlanEdu() {
      return this.hiddenPlanEdu && this.abTestOpenEdu
    },
    abTestOpenEdu() {
      return true
    },
  },
  mounted() {
    this.domain = Config.domain
    if (PLAN_GROUPS.includes(Utils.getParamValue('planGroup'))) {
      this.planName = Utils.getParamValue('planGroup')
    }

    EventBus.$on('clickShowEduPlan', () => {
      this.openEducation(true)
    })
  },
  destroyed() {
    EventBus.$off('clickShowEduPlan')
  },
  methods: {
    openEducation(fromMobile = false) {
      Utils.gaTrackEvent('My plan', 'Show Plan Edu')
      this.fromMobile = fromMobile
      this._togglePlan('educational')
    },
    backToNonEducational() {
      Utils.gaTrackEvent('My plan', 'Show Non-Edu Plans')
      this.showTitleOpenEdu = true
      this.$emit('back-to-non-edu', true)
      this._togglePlan('annual')
    },
    learnmore() {
      Utils.gaTrackEvent(gaCategories.MY_PLAN, 'Learn more', 'Click Learn more')
      const element = document.getElementById('sticky-wrapper')
      const top = element.offsetTop - 50
      window.scrollTo(0, top)
    },
    upgradePlan(planType) {
      Utils.gaTrackEvent('My plan > Upgrade > Top', 'Upgrade', planType)
      setTimeout(() => {
        window.location.href = `${Config.presenterDomain}/apps/upgrade/${planType}`
      }, 500)
    },
    togglePlanEduByPlan(plan) {
      if (plan !== 'educational') {
        this.showTitleOpenEdu = true
        this.hiddenPlanEdu = true
      } else {
        this.showTitleOpenEdu = false
      }
    },
    _togglePlan(plan) {
      if (!plan) return
      this.togglePlanEduByPlan(plan)
      this.planName = plan
      Utils.gaTrackEvent(
        gaCategories.MY_PLAN,
        'Change Plan Tab',
        plan,
      )
    },
    _showMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.remove('active')
      hideDetails.classList.add('active')
      details.classList.add('active')
      this.planColour = planColour
      this.planName = planName
    },
    _hideMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.add('active')
      hideDetails.classList.remove('active')
      details.classList.remove('active')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.pricing-container {
  @apply py-4 w-full;
}
.pricing-toggle {
  @apply flex justify-between;
}

.pricing-mobile {
  font-size: 14px;
  display: none;
  margin-top: 16px;
  &::v-deep {
    .mct-card__title-info {
      color: rgba(0, 0, 0, 0.4);
    }

    .action-button {
      width: 140px;
    }
    .mct {
      background: none;
    }
    .justify-between {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }
    .items-center {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .flex {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .mct-card__desc {
      margin-bottom: 10px;
    }
  }
}

.active {
  display: block !important;
}

.pricing-mobile {
  display: none;
}

@media (max-width: 1280px) {
  .pricing-mobile.is-touch {
    display: block;
  }
  .pricing-desktop.is-desktop {
    display: none;
    &::v-deep {
      .mc__card-wrapper {
        display: block;
        flex-grow: initial;
        flex-basis: initial;
        -webkit-box-flex: initial;
        position: initial;
        margin: 0;
        margin-bottom: 16px;
      }
      .mc__cards {
        display: block;
      }
    }
  }
}
.toggle__bar {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 2px 3px;
  -ms-flex-item-align: start;
  align-self: flex-start;
  -webkit-box-ordinal-group: 2;
  -ms-flex-order: 1;
  order: 1;
  max-width: 420px;
  @apply rounded-3xl border border-solid w-full text-center mr-0 bg-base-0;
}

.toggle__marker {
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  -o-transition: transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  will-change: transform;
  height: 34px;
  background-color: #2181c2;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

@media (max-width: 768px) {
  .pricing-toggle {
    display: block;
  }
  .toggle__bar {
    margin: 0 auto 1.5rem;
  }
}
@media (max-width: 479px) {
  .toggle__title__subtitle-small {
    font-size: 14px;
  }
  .toggle__marker {
    width: 70px;
  }
  .toggle__marker.annual {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .toggle__marker.monthly {
    -webkit-transform: translateX(67px);
    -ms-transform: translateX(67px);
    transform: translateX(67px);
  }
  .toggle__marker.one-time {
    -webkit-transform: translateX(135px);
    -ms-transform: translateX(135px);
    transform: translateX(135px);
  }
  .toggle__marker.educational {
    -webkit-transform: translateX(203px);
    -ms-transform: translateX(203px);
    transform: translateX(203px);
  }
}

@media (min-width: 480px) {
  .toggle__marker {
    width: 104px;
  }
  .toggle__marker.annual {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .toggle__marker.monthly {
    -webkit-transform: translateX(101px);
    -ms-transform: translateX(101px);
    transform: translateX(101px);
  }
  .toggle__marker.one-time {
    -webkit-transform: translateX(204px);
    -ms-transform: translateX(204px);
    transform: translateX(204px);
  }
  .toggle__marker.educational {
    -webkit-transform: translateX(307px);
    -ms-transform: translateX(307px);
    transform: translateX(307px);
  }
}
.toggle__button {
  -webkit-transition: color 0.3s ease;
  -o-transition: color 0.3s ease;
  transition: color 0.3s ease;
  border-radius: 20px;
  color: rgba(0, 0, 0, 0.75);
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 34px;
  line-height: 34px;
  position: relative;
  z-index: 2;
}

.toggle__button.active {
  background-color: $primary-color;
  color: #fff;
}

@media (min-width: 540px) {
  .toggle__button {
    font-size: 16px;
  }
}
#toggle-plan-one-time.active,
#toggle-plan-monthly.active,
#toggle-plan-annual.active,
#toggle-plan-educational.active {
  display: block !important;
}

#toggle--one-time.active,
#toggle--monthly.active,
#toggle--annual.active,
#toggle--educational.active {
  display: block !important;
}

#one-time-title.active,
#monthly-title.active,
#annual-title.active,
#educational-title.active {
  display: block !important;
}

.toggle__title__subtitle-small {
  color: rgba(0, 0, 0, 0.4);
}

//SVGs
.mc__card-image {
  position: absolute;
  top: 0;
  z-index: 1;
  width: 298px;
  opacity: 0.75;
}

.mc__card-image--yellow {
  top: 179px;
  left: 198px;
}

.mc__card-image--yellow .splash {
  fill: #ffae09;
}

.mc__card-image--yellow svg {
  -webkit-transform: rotate(-103deg);
  -ms-transform: rotate(-103deg);
  transform: rotate(-103deg);
}

.mc__card-image--green {
  top: -5px;
  right: 242px;
}

.mc__card-image--green .splash {
  fill: #28c270;
}

.mc__card-image--purple {
  top: 190px;
  right: -33px;
}

.e {
  fill: none;
  stroke: #d73b0a;
}

.mc__card-image--purple .splash {
  fill: #7669bf;
}

.mc__card-image--purple svg {
  -webkit-transform: rotate(-53deg);
  -ms-transform: rotate(-53deg);
  transform: rotate(-53deg);
}

.compare-button {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.75);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  font-size: 16px;
  padding: 10px 0;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
}

//Mobile
button {
  cursor: pointer;
  width: 110px;
}

button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}

.title-open-edu{
  margin-top: 1.5rem;
  text-align: center;
  font-size: 1rem;
  span{
    b{
      font-size: 1.125rem;
    }
  }
  a{
    font-weight: 700;
    font-size: 16px;
  }
  svg{
    display: inline-block;
    vertical-align: baseline;
  }
}

.back-non-edu-plan{
  width: 100%;
  max-width: 442px;
  font-size: 1rem;
  text-align: right;
  font-weight: 700;
}
.pricing-container-mobile{
  padding-top: 0;
  .back-non-edu-plan_mobile {
    padding-left: 10px;
    padding-right: 10px;
    svg {
      display: inline-block;
      vertical-align: baseline;
    }

    a {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
    }

    margin-bottom: 15px;
    display: block;
    text-align: left;
  }
}

@media (min-width: 1281px) {
  .pricing-container{
    .back-non-edu-plan_mobile{
      display: none;
    }
  }
}

@media (max-width: 1280px) {
  .back-non-edu-plan_desktop{
    display: none;
  }
}

@media (min-width: 480px) and (max-width: 1281px) {
  .pricing-container-mobile{
    .container-back-non-edu-plan{
      display: flex;
      justify-content: center;

      .back-non-edu-plan_mobile{
        text-align: center;
      }
    }
  }

  .pricing-toggle{
    &.show-edu-plan{
      justify-content: center;
    }
  }
}

</style>
